import React from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/de';

// Set dayjs locale globally
dayjs.locale('de');

const CustomTimePicker = ({ 
  value, 
  onChange, 
  label, 
  required = false,
  inputProps = {},
  sx = {},
  ...otherProps 
}) => {
  const handleChange = (newValue) => {
    if (onChange) {
      // Convert dayjs to HH:mm format to match native input behavior
      const event = {
        target: {
          value: newValue ? dayjs(newValue).format('HH:mm') : ''
        }
      };
      onChange(event);
    }
  };

  // Parse value: if it's HH:mm format, convert to dayjs
  const parseValue = () => {
    if (!value) return null;
    if (typeof value === 'string' && value.match(/^\d{2}:\d{2}$/)) {
      // Format is HH:mm
      const [hours, minutes] = value.split(':');
      return dayjs().hour(parseInt(hours)).minute(parseInt(minutes));
    }
    return dayjs(value);
  };

  return (
    <LocalizationProvider 
      dateAdapter={AdapterDayjs} 
      adapterLocale="de"
      localeText={{
        cancelButtonLabel: 'Abbrechen',
        clearButtonLabel: 'Löschen',
        okButtonLabel: 'OK',
        todayButtonLabel: 'Heute',
      }}
    >
      <TimePicker
        value={parseValue()}
        onChange={handleChange}
        label={label}
        ampm={false}
        slotProps={{
          textField: {
            required: required,
            variant: "outlined",
            size: "small",
            InputLabelProps: { shrink: true },
            sx: {
              width: '130px',
              ...sx,
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--rd-primary)',
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: 'var(--rd-primary)',
              },
            },
            ...otherProps
          },
          openPickerButton: {
            sx: {
              color: 'var(--rd-primary)',
              '&:hover': {
                backgroundColor: 'color-mix(in srgb, var(--rd-primary) 4%, transparent)',
              },
            }
          },
          actionBar: {
            actions: ['cancel', 'accept'],
          }
        }}
        sx={{
          '& .MuiClockNumber-root': {
            '&.Mui-selected': {
              backgroundColor: 'var(--rd-primary) !important',
            },
          },
          '& .MuiClock-pin': {
            backgroundColor: 'var(--rd-primary) !important',
          },
          '& .MuiClockPointer-root': {
            backgroundColor: 'var(--rd-primary) !important',
          },
          '& .MuiClockPointer-thumb': {
            backgroundColor: 'var(--rd-primary) !important',
            borderColor: 'var(--rd-primary) !important',
          },
          '& .MuiPickersArrowSwitcher-button': {
            color: 'var(--rd-primary)',
          },
          '& .MuiDialogActions-root .MuiButton-root': {
            color: 'var(--rd-primary)',
            '&:hover': {
              backgroundColor: 'color-mix(in srgb, var(--rd-primary) 4%, transparent)',
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomTimePicker;

